<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">卡券转让</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 顶部tab  开始 -->
    <div class="page_tab">
      <div class="page_tablist" v-for="(item,index) in tabs" @click="changetabs(index)">
        <div :class="item.select ? 'page_tabname':'page_tabname1'">{{item.name}}</div>
      </div>
    </div>
    <!-- 顶部tab  结束 -->
    <!-- 转让  开始 -->
    <!-- <div class="page_top">
      <div class="tixian_top">
        <div class="tixian_num">{{amount}}</div>
        <div class="tixian_num">可转让积分</div>
      </div>
    </div> -->

    <div class="page_top">
      <div class="tixian_top1">
        <div class="tixian_jifen1">
          <div class="tixian_jifennum1">{{amount}}</div>
          <div class="tixian_jifentext1">可转让积分</div>
        </div>
        <div class="tixian_kaquanList1" @click="tixianjilu()">转让记录</div>
      </div>
    </div>
    <!-- 转让  结束 -->
    <!-- 转让表单  开始 -->
    <div class="page_taocan tixian_taocan" :style="haveRedeemCode != true? 'height:100%;' : ''">
      <div class="tixian_input" v-if="tabsId !=3">
        <div class="tixian_title">{{tabsId ===1? '银行卡号' : (tabsId ===2? '支付宝号' : '微信帐号')}}:</div>
        <!--    <div class="tixian_title">{{tabsId ===1? '银行卡号' :  '微信帐号'}}:</div> -->
        <!--   <div class="tixian_checkbox"> -->
        <div @click="showPopup()" v-if="cardNo==''" class="tixian_checkbox">
          <div class="tixian_check">请选择账户</div>
          <img class="tixian_checkimg" src="/static/newicon/more.png" />
        </div>
        <div @click="showPopup()" v-else class="tixian_checkbox">{{cardNo}}</div>
        <!-- </div> -->
      </div>
      <div class="tixian_inputfrom" v-if="haveRedeemCode == true">
        <div class="tixian_checktitle">转让验证码:</div>
        <input class="tixian_checkinput" placeholder="请输入转让验证码" v-model="redeemCode" />
      </div>
      <!-- <div class="tixian_inputfrom">
        <div class="tixian_checktitle">转让积分:</div>
        <input class="tixian_checkinput" placeholder="请输入转让积分" @input="jiInput($event)" v-model="timoney" />
      </div> -->
      <div class="tixian_inputfrom">
        <div class="tixian_title">到账积分:</div>
        <!-- <input class="tixian_checkinput" disabled="true" value="" /> -->
        <!-- <div v-if="timoney" :class="{tixian_checkbox: daomoney}">{{daomoney? daomoney : '0.00'}}</div> -->
        <div class="tixian_checkbox">{{receivedAmount? receivedAmount : '0.00'}}</div>
        <!-- <div class="tixian_checkbox1" v-else>0.00</div> -->
      </div>
    </div>
    <!-- 转让表单  结束 -->
    <!-- 支付 开始 -->
    <div class="page_button" :class="haveRedeemCode != true? 'tixian_button' : ''" @click=" buttonClicked ? '' : tixian()">
      <div class="page_zhifu">确认转让</div>
    </div>
    <!-- 支付 结束 -->
    <!-- 注意事项  开始 -->
    <div class="page_mesg">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">温馨提示</div>
      </div>
      <div class="page_mesgtip">1.转让要收手续费，转让金额只能大于或等于1元</div>
      <div class="page_mesgtip page_mesgtipspan">2.工作日周一到周五09:00-18:00支付宝转让</div>
      <div class="page_mesgtip page_mesgtipspan">3.每日失败次数不得超过{{withdraw_fail_limit}}次</div>
    </div>
    <!-- 注意事项  结束 -->

    <!-- 弹出层  开始 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <div class="tixian_popup_top" @click="guanbi()">
        <img class="tixian_guanbi" src="/static/guanbi.png" />
        <div>{{tabsId===1? '选择银行卡' : '选择支付宝'}}</div>
      </div>
      <div v-if="tabsId === 1">
        <!--        <div v-for="(item,index) in oilCardList " :key="index" @click="buttonClicked ? '' : taplist(index) " id="binkCardIndexChange"
          class="weui-cell">
          <div class="weui-cell__bd">
            <div>{{ item.bank }}</div>
            <div class="greyColor">{{item.card_no}}</div>
          </div>
          <div @click.stop="tapyi(index)" id="binkCardIndexDelete" class="weui-cell__ft">
            <img src="/static/del.png" />
          </div>
        </div> -->
        <div v-for="(item,index) in oilCardList " :key="index" @click=" buttonClicked ? '' : taplist(index) " id="binkCardIndexChange"
          class="tixian_zhanghuList">
          <div class="tixian_zhanghutop">
            <div>{{ item.bank }}</div>
            <div class="greyColor">{{ item.card_no }}</div>
          </div>
          <div @click.stop="tapyi(index)" id="alipayIndexDelete" class="tixian_zhanghudel">
            <img src="/static/newprojecticon/del.png" class="tixian_delimg" />
          </div>
        </div>
      </div>
      <div v-if="tabsId === 2">
        <!--   <div v-for="(item,index) in alipayList " :key="index" @click=" buttonClicked ? '' : taplist1(index) " id="alipayIndexChange"
          class="weui-cell">
          <div class="weui-cell__bd">
            <div>{{ item.name }}</div>
            <div class="greyColor">{{ item.account }}</div>
          </div>
          <div @click.stop="tapzhi(index)" id="alipayIndexDelete" class="weui-cell__ft">
            <img src="/static/del.png" />
          </div>
        </div> -->
        <div v-for="(item,index) in alipayList " :key="index" @click=" buttonClicked ? '' : taplist1(index) " id="alipayIndexChange"
          class="tixian_zhanghuList">
          <div class="tixian_zhanghutop">
            <div>{{ item.name }}</div>
            <div class="greyColor">{{ item.account }}</div>
          </div>
          <div @click.stop="tapzhi(index)" id="alipayIndexDelete" class="tixian_zhanghudel">
            <img src="/static/newprojecticon/del.png" class="tixian_delimg" />
          </div>
        </div>
      </div>
      <div v-if="tabsId === 3" @click="tip()">
      </div>
      <div class="zhanghuList" @click="tocardWithdrawAdd" v-if="tabsId === 1">
        <div class="zhanghuName">添加银行卡</div>
        <img src="/static/xiangyou.png" class="zhanghuselect" />
      </div>
      <div class="zhanghuList" @click="tocardWithdrawAdd" v-if="tabsId === 2">
        <div class="zhanghuName">添加支付宝账号</div>
        <img src="/static/xiangyou.png" class="zhanghuselect" />
      </div>
    </van-popup>
    <!-- 弹出层  结束 -->
    <!-- <div class="tixianjil" @click="tixianjilu">提现记录</div> -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import checkweekend from '../../plugins/check-weekend.js'
  import {
    Dialog
  } from 'vant';
  import {
    Toast
  } from 'vant';
  // import Vconsole from 'vconsole';
  // var vConsole = new VConsole();
  const openLoading = () => {
    Toast.loading({
      message: "加载中",
      duration: 0, // toast不消失
    });
  }
  // const closeLoading = debounce(() => {
  //   if (!RequestStack.length) {
  //     Toast.clear();
  //   }
  // }, 100)
  const closeLoading = setTimeout(() => {
    Toast.clear();
  }, 100)

  export default {
    data() {
      return {
        //顶部tabs列表
        tabs: [{
          name: "银行卡",
          select: true,
          id: 1
        }, {
          name: "支付宝",
          select: false,
          id: 2
        }, {
          name: "微信",
          select: false,
          id: 3
        }, ],
        // tabs: [{
        //   name: "银行卡",
        //   select: true,
        //   id: 1
        // }, {
        //   name: "微信",
        //   select: false,
        //   id: 3
        // }, ],
        tabsindex: 0, //tabs列索引
        tabsId: 1,
        buttonClicked: false, // 防止支付重复点击,默认为false
        amount: '', // 接口获取余额
        sureList: [], //接口领取通用卡前确认列表数据
        chongzhiisselect: true,
        selectIndex: 0,
        checknum: "", //选择的积分
        shownum: false, //是否选择积分
        timoney: '', //转让的金额
        daomoney: '', //到账的金额
        showDialog: false, //weui的数据
        showTopTips: [{
            text: '输入不能有空!',
            checked: false
          },
          {
            text: '当前账号没有可领取的卡券!',
            checked: false
          },
          {
            text: '验证码输入有误!',
            checked: false
          },
          {
            text: '请输入您的手机号码!',
            checked: false
          },
          {
            text: '请输入正确的兑换密码!',
            checked: false
          },
          {
            text: '请输选择转让账户!',
            checked: false
          },
          {
            text: '转让积分不能大于可用积分!',
            checked: false
          },
          {
            text: '转让积分要大于或等于100!',
            checked: false
          },
          {
            text: '转让积分要小于等于2000!',
            checked: false
          }
        ], // 错误提示列表

        oilzhangItem: {}, //从上一页面传过来的银行卡转让账户
        alipayitem: {}, //从上一页面传过来的支付宝账号
        cardNo: "", //转让账户号码
        id: "", //转让账户id
        type: "", //转让账户类型
        istimoney: true, //转让的金额是否大于余额
        withdraw_fail_limit: "",
        withdraw_money_limit: "",
        withdraw_radio: "",
        failnum: 0,
        show: false,
        alipayList: [], //支付宝列表
        oilCardList: [], //银行卡列表
        oilCardIndex: 0, // 账户指针,默认为0
        carnumlast: "",
        redeemCode: "", //转让验证码
        // code:""
        checkList: [],
        haveRedeemCode: false,
        isWeekend: true,
        receivedAmount: "",
        userInfo: "",
        withdraw_bank_lowest: "", //银行卡可提现额度
        withdraw_weekend: [], //周末可提现数组
        withdrawopen: false,
        openId:''
      }
    },
    created() {
      this.request('getUserInfo')
      this.request("syswithdrawopen")
      if (sessionStorage.getItem("source") == "sjcmdl" || sessionStorage.getItem("source") == "cxkjdl") {
        this.tabs = [{
          name: "银行卡",
          select: true,
          id: 1
        }, {
          name: "支付宝",
          select: false,
          id: 2
        }]
      }
      let that = this
      console.log("openid",this.getQueryString('openid'))
      if(this.getQueryString('openid')){
        this.openId = this.getQueryString('openid')
        localStorage.setItem('openId', JSON.stringify({ data: that.openId, expires: Date.now() + 86400000 }));
        that.tabsindex = 2
        that.tabsId = 3
        that.tabs[0].select = false
        that.tabs[1].select = false
        that.tabs[2].select = true
      }
      if(this.getQueryString('amount')){
        this.amount = this.getQueryString('amount')
      }
      if(this.getQueryString('receivedAmount')){
        this.formatDecimal((this.getQueryString('receivedAmount')), 2)
      }
      if(this.getQueryString('checkList')){
        this.checkList = JSON.parse(this.getQueryString('checkList'))
      }
      if(this.getQueryString('haveRedeemCode')){
        this.haveRedeemCode = this.getQueryString('haveRedeemCode')
      }
      if (this.$route.query.amount) {
        this.amount = this.$route.query.amount
      }
      if (this.$route.query.receivedAmount) {
        this.formatDecimal((this.$route.query.receivedAmount), 2)
        // this.receivedAmount = (this.$route.query.receivedAmount).toFixed(2)
      }
      if (this.$route.query.checkList) {
        this.checkList = JSON.parse(this.$route.query.checkList)
      }
      console.log("this.checkList", this.checkList)
      if (this.$route.query.haveRedeemCode) {
        this.haveRedeemCode = this.$route.query.haveRedeemCode
      }
      console.log("haveRedeemCode", this.haveRedeemCode)
      this.request("getWithdrawParams")
      this.request("getAlipayList")
      this.request("getBinkCardList")
      this.getDay()


      // that.getwith()
      //账户列表传来的参数
      //  console.log("that.$route.params.carditem",that.$route.params.carditem)
      // if (that.$route.params.carditem) {
      //   that.cardNo = that.$route.params.carditem.cardNo
      //   that.id = that.$route.params.carditem.id
      //   that.oilzhangItem = that.$route.params.carditem
      //   console.log('oilzhangItem', that.oilzhangItem)
      // }
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        if (window.location.hash.indexOf("?") < 0) return null;
        let r = window.location.hash.split("?")[1].match(reg);
        if (r != null) return decodeURIComponent(r[2]);
        return null;
      },
      formatDecimal(num, decimal) {
        num = num.toString()
        let index = num.indexOf('.')
        if (index !== -1) {
          num = num.substring(0, decimal + index + 1)
        } else {
          num = num.substring(0)
        }
        this.receivedAmount = parseFloat(num).toFixed(decimal)
        console.log("this.receivedAmount", this.receivedAmount)
        // return parseFloat(num).toFixed(decimal)
      },
      // //屏幕宽度
      // getwith() {
      //   let html = document.querySelector("html");
      //   let width = html.getBoundingClientRect().width;
      //   html.style.fontSize = width / 3.75 + 'px';
      //   console.log("宽度", html.style.fontSize)
      // },
      //改变tabs切换
      changetabs(e) {
        let that = this
        let tabs = that.tabs
        tabs.map((item, index) => item.select = index === Number(e))
        // that.tabsindex = Number(e)
        that.tabsId = tabs[Number(e)].id
        that.cardNo = ""
        if (!this.withdrawopen) {
          if (that.tabsId == 3) {
            Dialog.alert({
              title: '提示',
              message: '此功能维护中!',
            }).then(() => {
              that.tabsindex = 0
              that.tabsId = 1
              that.tabs[2].select = false
              that.tabs[0].select = true
            });
          }
        }else{
          localStorage.removeItem('url');
          localStorage.removeItem('withdrawType');
          let source = sessionStorage.getItem("source")
          let amount= this.amount
          let receivedAmount = this.receivedAmount
          let checkList= JSON.stringify(this.checkList)
          let haveRedeemCode=this.haveRedeemCode
          let url = `https://yxm.youxiangchewang.com/?source=${source}#/cardWithdraw?amount=${amount}&receivedAmount=${receivedAmount}&checkList=${checkList}&haveRedeemCode=${haveRedeemCode}`
          localStorage.setItem('url',url)
          localStorage.setItem('withdrawType','cardWithdraw')
          if (that.tabsId == 3) {
            let openId = ''
            if(JSON.parse(localStorage.getItem('openId'))){
              // 获取数据
              openId = JSON.parse(localStorage.getItem('openId'));
              // 检查缓存是否过期
              if (openId.expires > Date.now()) {
                console.log("缓存数据openId未过期");
                this.openId = openId.data
              } else {
                console.log("缓存数据openId已过期");
                this.$router.push({
                  path:'/withdrawal'
                })
              }
            }else{
              this.$router.push({
                path:'/withdrawal'
              })
            }
          }
        }
        // var userId = [42, 45, 46, 49, 50, 86, 167, 168]
        // var availableUser = true
        // for (var i = 0; i < userId.length; i++) {
        //   if (userId[i] == that.userInfo.id) {
        //     availableUser = false
        //   }
        // }
        // if (that.tabsId == 3 && availableUser) {
        //   Dialog.alert({
        //     title: '提示',
        //     message: '微信提现维护中',
        //   }).then(() => {
        //     that.tabsindex = 0
        //     that.tabsId = 1
        //     that.tabs[2].select = false
        //     that.tabs[0].select = true
        //   });
        // }

        // //   console.log("availableUser",availableUser)
        // if (that.tabsId == 3) {
        //   Dialog.alert({
        //     title: '提示',
        //     message: '微信提现维护中',
        //   }).then(() => {
        //     that.tabsindex = 0
        //     that.tabsId = 1
        //     that.tabs[2].select = false
        //     that.tabs[0].select = true
        //   });
        // }
        // if (that.tabsId == 2  && availableUser) {
        //   Dialog.alert({
        //     title: '提示',
        //     message: '此功能维护中!',
        //   }).then(() => {
        //     that.tabsindex = 0
        //     that.tabsId = 1
        //     that.tabs[1].select = false
        //     that.tabs[0].select = true
        //   });
        // }
      },
      getDay() {
        checkweekend.checkWeekend()
        this.isWeekend = checkweekend.checkWeekend()
        console.log("isweek", checkweekend.checkWeekend())
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },

      showPopup() {
        this.show = true
      },
      //输入转让积分
      jiInput(e) {
        let that = this
        let showTopTips = this.showTopTips
        let timoney = that.timoney.replace(/\s*/g, '')
        console.log('总积分', parseInt(that.amount))
        console.log("转让积分", parseInt(timoney))
        that.timoney = timoney
        let daomoney = (Number(that.timoney) * that.withdraw_radio).toFixed(2)
        that.daomoney = daomoney
        console.log('daomoney', that.daomoney)
      },
      //点击转让
      tixian() {
        this.buttonClickedFun(10000)
        let that = this
        let codeList = []
        if (that.isWeekend == false) {
          var withdrawWeekend = that.withdraw_weekend
          var isbank = withdrawWeekend.includes("2")
          var iszhi = withdrawWeekend.includes("1")
          var isweichar = withdrawWeekend.includes("3")
          if (that.tabsId == 1 && isbank == false) {
            that.$toast({
              message: '非工作日，银行卡不可转让',
            });
            return
          }
          if (that.tabsId == 2 && iszhi == false) {
            that.$toast({
              message: '非工作日，支付宝不可转让',
            });
            return
          }
          if (that.tabsId == 3 && isweichar == false) {
            that.$toast({
              message: '非工作日，微信不可转让',
            });
            return
          }
        }
        // if (that.isWeekend == false) {
        //   that.$toast({
        //     message: '非工作日，不可转让',
        //   });
        //   return
        // }
        for (var i = 0; i < this.checkList.length; i++) {
          if (this.checkList[i].sendLog.code) {
            codeList.push(this.checkList[i].sendLog.code)
          }
          console.log("this.checkList[i].sendLog", this.checkList[i].sendLog)
        }
        console.log("codeList", codeList)
        if (!that.cardNo && that.tabsId != 3) {
          that.$toast({
            message: '请输选择转让账户',
          });
          return
        }
        console.log("that.haveRedeemCode", that.haveRedeemCode)
        if (that.haveRedeemCode == true) {
          if (!that.redeemCode) {
            that.$toast({
              message: '请输入验证码',
            });
            return
          }
        }
        if (that.withdraw_bank_lowest) {
          if (that.tabsId == 1 && parseFloat(that.amount) < parseFloat(that.withdraw_bank_lowest)) {
            var toast_tip = true;
            var userId = [42, 46, 86, 168]
            var userInfo = JSON.parse(localStorage.getItem("userinfo"));
            console.log('userInfo.id', userInfo.id)
            for (let i = 0; i < userId.length; i++) {
              if (userId[i] == userInfo.id) {
                toast_tip = false;
              }
            }

            if (toast_tip) {
              that.$toast({
                message: '银行卡提现积分要大于' + that.withdraw_bank_lowest,
              });
              return
            }
            // that.$toast({
            //   message: '银行卡提现积分要大于' + that.withdraw_bank_lowest,
            // });
            // return
          }
        }
        // that.request("cardWithdraw", {
        //   code: codeList,
        //   withdraw_type: that.type,
        //   account_id: that.id,
        //   redeem_code: that.redeemCode
        // })
        if (that.tabsId != 3) {
          openLoading()
          that.request("cardWithdraw", {
            code: codeList,
            withdraw_type: that.type,
            account_id: that.id,
            redeem_code: that.redeemCode
          })

        } else {
          openLoading()
          that.request("cardWithdraw", {
            code: codeList,
            withdraw_type: 3,
            redeem_code: that.redeemCode,
            card_no:that.openId
          })
        }
      },
      //所选银行账户
      taplist(e) {
        let that = this
        that.cardNo = that.oilCardList[e].card_no
        that.id = that.oilCardList[e].id
        that.type = 2
        this.show = false
      },
      //所选支付宝账户
      taplist1(e) {
        let that = this
        that.cardNo = that.alipayList[e].account
        console.log("111zhifubao", that.alipayList[e])
        that.id = that.alipayList[e].id
        that.type = 1
        this.show = false
      },
      //跳转新增账户页面
      tocardWithdrawAdd() {
        if (this.tabsId == 1) {
          this.tabsindex = 0
        } else {
          this.tabsindex = 1
        }
        this.$router.push({
          path: '/cardWithdrawAdd',
          query: {
            tabsid: this.tabsindex,
            amount: this.amount,
            checkList: JSON.stringify(this.checkList),
            haveRedeemCode: this.haveRedeemCode
          }
        })
      },
      tip() {
        this.$toast({
          message: '此功能暂未开放',
        });
      },
      //关闭弹出层
      guanbi() {
        this.show = false
      },
      //删除银行卡
      tapyi(e) {
        let that = this
        this.show = false
        Dialog.confirm({
            title: '提示',
            message: '确认删除银行卡指定账户',
          })
          .then(() => {
            let idi = that.oilCardList[Number(e)].id //动态获取删除该条数据的id
            console.log("id", that.oilCardList[Number(e)].id)
            let requestData = {
              id: idi
            }
            that.request('delBinkCard', requestData)
            that.oilCardList.splice(Number(e), 1)
            if (that.oilCardList.length && that.oilCardList.every(item => item.checked === false)) that.oilCardList[
              0].checked = true
            let oilCardList1 = that.oilCardList
            that.oilCardList = oilCardList1
          })
          .catch(() => {
            return false;
          });
      },
      tapzhi(e) {
        let that = this
        this.show = false
        Dialog.confirm({
            title: '提示',
            message: '确认删除支付宝指定账户',
          })
          .then(() => {
            let idi = that.alipayList[Number(e)].id //动态获取删除该条数据的id
            console.log("id", that.alipayList[Number(e)].id)
            let requestData = {
              id: idi
            }
            that.request('delAlipay', requestData)
            that.alipayList.splice(Number(e), 1)
            console.log('alipayList', that.alipayList)
            if (that.alipayList.length && that.alipayList.every(item => item.checked === false)) that.alipayList[0]
              .checked = true
            let alipayList1 = that.alipayList
            that.alipayList = alipayList1
          })
          .catch(() => {
            return false;
          });
      },
      //进入提现列表
      tixianjilu() {
        this.$router.push({
          path: "/withdrawList"
        })
      },

      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code === 0) {
                let userinfo = res.data
                console.log('userinfo', userinfo)
                that.userInfo = userinfo
                // sessionStorage.setItem('userinfo', JSON.stringify(userinfo))
                // that.phoneNum = userinfo.mobile ? userinfo.mobile : 'meiyou'
                // that.amount = userinfo.account.amount
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
            //微信提现是否开启
          case 'syswithdrawopen':
            httper.get('sys/withdraw-open', requestData, res => {
              if (res.code === 0) {
                that.withdrawopen = res.data.wechat
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
          case 'cardWithdraw':
            //转让
            httper.post('/card/transfer', requestData, res => {
              if (res.code === 0) {
                // if (res.status == 500) {
                //   this.$toast({
                //     message: '提交失败',
                //   });
                //   return
                // }
                //closeLoading()
                setTimeout(() => {
                  Toast.clear();
                }, 100)
                Dialog.alert({
                  title: '提示',
                  message: '提交成功',
                }).then(() => {
                  that.$router.push({
                    name: 'withdrawList',
                  })
                });
              } else {
                //closeLoading()
                setTimeout(() => {
                  Toast.clear();
                }, 100)
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
            //获取转让配置数据
          case 'getWithdrawParams':
            httper.get('sys/withdraw-params', requestData, res => {
              if (res.code == 0) {
                console.log("res", res)
                that.withdraw_fail_limit = res.data.withdraw_fail_limit
                  that.withdraw_money_limit = res.data.withdraw_money_limit
                  console.log('that.withdraw_money_limit', that.withdraw_money_limit)
                that.withdraw_radio = res.data.withdraw_radio
                let daomoney = (Number(that.amount) * res.data.withdraw_radio).toFixed(2)
                console.log("daomoney", daomoney)
                that.daomoney = daomoney
                that.withdraw_bank_lowest = res.data.withdraw_bank_lowest
                that.withdraw_weekend = res.data.withdraw_weekend
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            })
            break
            // 获取支付宝账号列表
          case 'getAlipayList':
            httper.get('user/alipay-list', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                console.log(res.data)
                res.data.map((item, index) => item.checked = index === that.oilCardIndex)
                that.alipayList = res.data

              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
            //获取银行卡列表
          case 'getBinkCardList':
            httper.get('user/bank-card-list', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                console.log("1", res.data)
                res.data.map((item, index) => item.checked = index === that.oilCardIndex)
                that.oilCardList = res.data
                that.carnumlast = res.data[that.oilCardIndex] ? res.data[that.oilCardIndex].card_no.substr(-4) : ''
                console.log("carnumlast", that.carnumlast)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
            // 删除支付宝列表
          case 'delAlipay':
            httper.get('user/del-alipay', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                console.log(res.data)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break
            // 删除银行卡列表
          case 'delBinkCard':
            httper.get('user/del-bank-card', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                console.log(res.data)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                });
              }
            }, true)
            break

        }
      },
    }
  }
</script>

<style scoped>
  .tixian_top {
    /* height: 53px; */
    height: 53px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px;
    padding: 10px;
    color: #fff;
    font-size: 15px;
  }

  .tixian_top1 {
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
  }

  .tixian_jifen1 {}

  .tixian_jifennum1 {
    font-size: 26px;
  }

  .tixian_jifentext1 {
    font-size: 13px;
    font-weight: 400;
    color: rgba(247, 247, 247, 1);
  }

  .tixian_kaquanList1 {
    width: 61px;
    height: 23px;
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 11px;
    font-size: 10px;
    color: rgba(247, 247, 247, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tixian_num {
    margin-bottom: 10px;
  }

  .tixian_input {
    display: flex;
    height: 20px;
    margin-bottom: 20px;
    margin-top: 10px;

  }

  .tixian_title {
    margin: 0 13px 0 5px;
    /* width: 60px; */
    width: 62px;
  }

  .tixian_check {
    font-size: 14px;
    font-weight: 400;
    color: rgba(187, 187, 187, 1);
  }

  .tixian_checkimg {
    width: 15px;
    height: 15px;
  }

  .tixian_checkbox {
    width: 230px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tixian_checkbox1 {
    width: 230px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(187, 187, 187, 1);
  }

  .tixian_inputfrom {
    display: flex;
    align-items: center;
    margin: 40px 0;
  }

  .tixian_checktitle {
    margin: 0 13px 0 5px;
  }

  .tixian_checkinput {
    font-size: 14px;
    font-weight: 400;
    line-height: 23px;
    border: none;
    background-color: #fff;
  }

  ::-webkit-input-placeholder {
    text-align: start;
    color: rgba(187, 187, 187, 1);
    font-size: 14px;
  }

  .tixian_taocan {
    /*   top: 170px; */
    /* height: 110px; */
  }

  /* 弹出层 开始 */
  .tixian_popup_top {
    display: flex;
    height: 30px;
    padding: 16px;
    border-bottom: 1px solid #d6d6d6;
    align-items: center;
    font-size: 18px;
  }

  .tixian_guanbi {
    width: 20px;
    height: 20px;
    margin-right: 130px;
  }

  .zhanghuList {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #d6d6d6;
  }

  .zhanghuName {}

  .zhanghuselect {
    width: 20px;
    height: 20px;
  }

  .tixian_zhanghuList {
    /* position: relative; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
  }

  .tixian_zhanghutop {}

  .tixian_zhanghudel {}

  .tixian_delimg {
    width: 30px;
    height: 30px;
  }

  .tixianjil {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FD8C00;
  }

  .tixian_button {
    /* margin-top: 85px; */
  }

  /*  .weui-cell__ft img {
    width: 30px;
    height: 30px;
  }

  .weui-cell {
    position: relative;
    display: flex;
    align-items: center;
  }

  .weui-cell__ft {
    text-align: right;
    color: rgba(0, 0, 0, 0.5);
    color: var(--weui-FG-1);
  } */

  /* 弹出层 结束 */
</style>



// WEBPACK FOOTER //
// src/pages/account/cardWithdraw.vue